import { SmIcon } from '@smiles/smiles-react-design-system';
import React, { useEffect, useRef } from 'react';

import { useContextSelector } from '../../hooks';
import type { RentalType } from '../../types';

export interface ITimeListItemProps {
  text: string;
  type: RentalType;
  onSelect: (item: string) => void;
}

export const TimeListItem = ({ text, type, onSelect, ...props }: ITimeListItemProps) => {
  const {
    generics: { isMobile },
    search: { time },
  } = useContextSelector();
  const itemRef = useRef<HTMLLIElement>(null);

  const updateAllLi = () => {
    const component = itemRef.current as HTMLLIElement;
    const ul = component.parentElement as HTMLUListElement;

    ul.querySelectorAll('li').forEach((li) => {
      if (li.classList.contains('selected')) {
        li.classList.remove('selected');
      }
    });

    component.classList.add('selected');
  };

  useEffect(() => {
    if (time[type] && text === time[type]) {
      updateAllLi();
    }
  }, []);

  const handleItemClick = () => {
    updateAllLi();
    onSelect(text);
  };

  return (
    <li className="time-list-item" role="time-list-item" ref={itemRef} {...props}>
      <button className="time-list-item-button" type="button" onClick={handleItemClick}>
        <span className="time-list-item-text">{text}</span>

        {isMobile && <SmIcon className="time-list-item-selected-icon" name="check" type="round" />}
      </button>
    </li>
  );
};
